var React = require('react');

function IconYoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Zm7.665-19.24a2.022 2.022 0 0 0-1.41-1.455C20.002 9 15 9 15 9s-5.003 0-6.254.335a2.022 2.022 0 0 0-1.411 1.454A21.09 21.09 0 0 0 7 14.636a21.09 21.09 0 0 0 .335 3.876 2.021 2.021 0 0 0 1.41 1.396c1.252.335 6.255.335 6.255.335s5.003 0 6.254-.334a2.02 2.02 0 0 0 1.411-1.455c.227-1.26.34-2.538.335-3.818.008-1.3-.104-2.597-.335-3.876Zm-9.302 6.254 4.182-2.378-4.182-2.378v4.756Z","fill":"#fff"}));
}

IconYoutubeInline.defaultProps = {"width":"30","height":"30","fill":"none"};

module.exports = IconYoutubeInline;

IconYoutubeInline.default = IconYoutubeInline;
